/**
 * STAND-INS for Maritime `Avatar` and `CountBadge` — not in @syia-ai/maritimeai-ui 0.2.0
 * (its Badge is a status label, not a count over an icon). Delete once Maritime has them.
 */

export function Avatar({ initials, name }: { initials: string; name?: string }) {
  return (
    <span className="shell-avatar" role="img" aria-label={name || 'Account'} title={name}>
      {initials}
    </span>
  );
}

/** A small count drawn over an icon button's corner. Hidden at 0; caps at 99+. */
export function CountBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className="shell-count-badge" aria-hidden>
      {count > 99 ? '99+' : count}
    </span>
  );
}
